<section class="coupon-form-page">
  <app-admin-page-header [title]="title" [subtitle]="subtitle"></app-admin-page-header>

  <div class="admin-feedback admin-feedback--error" *ngIf="feedbackError">
    {{ feedbackError }}
  </div>

  <form class="coupon-form admin-surface" (ngSubmit)="submit()">
    <label class="coupon-form__bulk-toggle" *ngIf="!isEditMode">
      <input type="checkbox" name="isBulkCreate" [(ngModel)]="isBulkCreate" />
      Criar cupons em massa
    </label>
    <div class="coupon-form__grid">
      <label *ngIf="!isBulkCreate">
        <span>Nome do cupom</span>
        <input class="admin-input" name="name" [(ngModel)]="coupon.name" required />
      </label>
      <ng-container *ngIf="isBulkCreate">
        <label>
          <span>Prefixo dos cupons</span>
          <input class="admin-input" name="bulkPrefix" [(ngModel)]="bulkPrefix" maxlength="10" placeholder="Ex.: GBS26" />
          <small>Os códigos terão o formato PREFIXO-XXXX-XXXX.</small>
        </label>
        <label>
          <span>Quantidade</span>
          <input class="admin-input" type="number" name="bulkQuantity" [(ngModel)]="bulkQuantity" min="1" max="500" />
        </label>
      </ng-container>
      <label>
        <span>Desconto em porcentagem</span>
        <input class="admin-input" type="number" min="1" max="100" name="percentageDiscount" [(ngModel)]="coupon.percentage_discount" />
      </label>
      <label>
        <span>Desconto fixo</span>
        <input class="admin-input" type="number" min="1" name="fixedDiscount" [(ngModel)]="coupon.fixed_discount" />
      </label>
      <label>
        <span>Máximo de usos</span>
        <input class="admin-input" type="number" min="0" name="maxUsage" [(ngModel)]="coupon.coupons_max_usage" />
        <small>Use 0 para ilimitado.</small>
      </label>
      <label>
        <span>Account ID vinculado</span>
        <input class="admin-input" type="number" min="1" name="accountId" [(ngModel)]="coupon.account_id" />
        <small>Deixe em branco para não vincular a uma conta.</small>
      </label>
      <label>
        <span>Prazo de vencimento</span>
        <input class="admin-input" type="datetime-local" name="expirationDatetime" [(ngModel)]="coupon.expiration_datetime" />
        <small>Deixe em branco para o cupom não expirar.</small>
      </label>
    </div>

    <div class="coupon-form__toggles">
      <label><input type="checkbox" name="isActive" [(ngModel)]="coupon.is_active" /> Ativo</label>
      <label><input type="checkbox" name="oneTimeUse" [(ngModel)]="coupon.one_time_use" /> Uso único por usuário</label>
      <label><input type="checkbox" name="trustedOnly" [(ngModel)]="coupon.trusted_only" /> Exclusivo para usuários trusted</label>
    </div>

    <div class="coupon-form__footer">
      <button type="button" class="admin-btn admin-btn--secondary" routerLink="/dashboard/cupons">Cancelar</button>
      <button type="submit" class="admin-btn admin-btn--primary" [disabled]="isSaving">
        {{ isSaving ? 'Salvando...' : (isEditMode ? 'Salvar alterações' : (isBulkCreate ? 'Criar cupons' : 'Criar cupom')) }}
      </button>
    </div>
  </form>
</section>
